import React from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';

import CN from './DropdownMenuFooter.module.scss';

const DropdownMenuFooter = ({ children }) => {
  const { isDarkMode } = useTheme();

  return (
    <div
      data-bem="DropdownMenuFooter"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      {children}
    </div>
  );
};

export default DropdownMenuFooter;
